import React, { useState } from 'react';
import { Card, CardBody, Button, Input, FormGroup, Label } from 'reactstrap';

const ManualTokenRenewal = ({ countryId, onSuccess }) => {
  const [shortToken, setShortToken] = useState('');
  const [isRenewing, setIsRenewing] = useState(false);

  const handleManualRenewal = async () => {
    if (!shortToken.trim()) {
      alert('Please insert the temporary token');
      return;
    }

    setIsRenewing(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_WS_FUNCTION_URL}/facebook/renew-token`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            countryId,
            shortLivedToken: shortToken,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert(
          `Token successfully renewed! Expires in ${result.daysUntilExpiration} days.`,
        );
        setShortToken('');
        onSuccess();
      } else {
        alert(`Error: ${result.error}`);
      }
    } catch (error) {
      console.error('Error in manual renewal:', error);
      alert('Error renewing token');
    } finally {
      setIsRenewing(false);
    }
  };

  return (
    <Card>
      <CardBody>
        <h5 className="mb-3">🔧 Manual Renewal</h5>

        <div className="mb-3">
          <p className="text-muted mb-2">
            <strong>1.</strong> Go to{' '}
            <a
              href="https://developers.facebook.com/tools/explorer/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary">
              Facebook Graph API Explorer
              <i className="bx bx-link-external ml-1"></i>
            </a>
          </p>
          <p className="text-muted mb-2">
            <strong>2.</strong> Select your app and generate a token
          </p>
          <p className="text-muted mb-3">
            <strong>3.</strong> Paste the token below:
          </p>
        </div>

        <FormGroup>
          <Label for="tokenInput">Temporary Token</Label>
          <Input
            type="text"
            id="tokenInput"
            value={shortToken}
            onChange={(e) => setShortToken(e.target.value)}
            placeholder="Paste the Facebook temporary token"
            style={{
              fontFamily: 'Monaco, Menlo, Consolas, monospace',
              fontSize: '12px',
            }}
          />
        </FormGroup>

        <Button
          color="primary"
          onClick={handleManualRenewal}
          disabled={isRenewing || !shortToken.trim()}
          block>
          {isRenewing ? (
            <>
              <i className="bx bx-loader bx-spin mr-2"></i>
              Renewing...
            </>
          ) : (
            <>
              <i className="bx bx-check mr-2"></i>
              Renew Token
            </>
          )}
        </Button>

        <div className="mt-3">
          <small className="text-muted">
            <i className="bx bx-info-circle mr-1"></i>
            The inserted token will be automatically converted to a long-lived
            token valid for 60 days.
          </small>
        </div>
      </CardBody>
    </Card>
  );
};

export default ManualTokenRenewal;
